module.exports = __webpack_public_path__ + "media/images/home/concept_scene_1-b53bfa772973c28230c7065e1f98fd0c.png";